import React from "react";
import PropTypes from "prop-types";
import { Get } from "react-axios";

import { InsightsUrlProvider } from "./UrlProviders";

class InsightsGet extends React.Component {
  constructor(props) {
    super(props);
    this.onLoading = this.onLoading.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
    this.onError = this.onError.bind(this);
  }

  onLoading() {
    if (this.props.onLoading) {
      this.props.onLoading();
    }
  }

  onSuccess(response) {
    if (this.props.onSuccess) {
      this.props.onSuccess(response);
    } else if (this.props.onDone) {
      this.props.onDone();
    }
  }

  onError(error) {
    if (this.props.onError) {
      this.props.onError(error);
    } else if (this.props.onDone) {
      this.props.onDone();
    }
  }
}

InsightsGet.propTypes = {
  onLoading: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  onDone: PropTypes.func
};

export class InsightsInfoGet extends InsightsGet {
  render() {
    const { children, apiUrlProvider } = this.props;
    const params = {
      numResults: this.props.numResults
    };
    return (
      <Get
        url={apiUrlProvider.getInsightsInfoUrl()}
        params={params}
        onLoading={this.onLoading}
        onSuccess={this.onSuccess}
        onError={this.onError}
      >
        {(error, response, isLoading, makeRequest, axios) => {
          return typeof children === "function"
            ? children(error, response, isLoading, makeRequest, axios)
            : children;
        }}
      </Get>
    );
  }
}

InsightsInfoGet.propTypes = {
  ...InsightsGet.propTypes,
  apiUrlProvider: PropTypes.instanceOf(InsightsUrlProvider).isRequired
};
